/* istanbul ignore file */
import React from 'react';
import { Breadcrumbs, ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useAccountUrl } from 'domain/shared/account';

const AccountsBreadcrumbs = ({ children = null }: { children?: React.ReactNode }) => {
  const { getListUrl } = useAccountUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Accounts" link={getListUrl()} />
      {children}
    </Breadcrumbs>
  );
};

export default AccountsBreadcrumbs;
